<template>
  <div>
    <van-dialog v-model="show" show-cancel-button confirmButtonColor="#4fc08d" @cancel="report('no')" @confirm="report('ok')">
      <div class="box">
        <van-field v-if="inputType=='1'" label-width="50px" border v-model="hospital" label="医院" placeholder="请输入医院信息"/>
        <van-field v-if="inputType=='2'"  label-width="50px" border v-model="office" label="科室" placeholder="请输科室院信息"/>
        <van-field v-if="inputType=='3'"  label-width="50px" border v-model="title" label="职称" placeholder="请输入职称信息"/>
      </div>
    </van-dialog>s
  </div>
</template>

<script>
export default {
  name: "OpenInput",
  props: {
    inputType:String
  },
 
  data() {
    return {
      show: true,
      hospital: '',
      office:'',
      title:''
     
    }
  },
  methods: {
    report(val) {
      console.log(val);
      if (val === 'ok') {
        console.log("111111111111111111111111111111");
        if(this.inputType==='1'){
          if (this.hospital === '') {
          this.$toast('请输入医院信息')
        } else {
          this.$emit('change', {value:this.hospital,type:'1'})
        }
        }else if(this.inputType==='2'){
          if (this.office === '') {
          this.$toast('请输入科室信息')
        } else {
          this.$emit('change', {value:this.office,type:'2'})
        }

        }else if(this.inputType==='3'){
          if (this.title === '') {
          this.$toast('请输入职称信息')
        } else {
          this.$emit('change', {value:this.title,type:'3'})
        }
        }

       
      } else {
        this.$emit('cancel')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 40px;
  padding-top: 60px;
}
</style>
